import { Component, OnInit } from '@angular/core';
import { HelpConsts } from '../../../help/models/help-consts';
import { HelpModalService } from '../../../help/services/help-modal.service';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { OurUserService } from '../../../users/services/user.service';
import { EcaBreadcrumbService } from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import { EcaDynamicModalService } from '../../../shared/services/eca-dynamic-modal-service';
import { MenuItem } from 'primeng/api';
import { IUserInfo } from '../../../users/models/userInfo.interface';
import { IEcaDialogRef } from '../../../shared/models/eca-dialog-ref.interface';
import { IBreadcrumb } from '../../../eca-breadcrumb/models/breadcrumb.interface';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { EcaConfirmDeleteModalOptions } from '../../../shared/models/confirm-delete-modal-options.class';
import { EcaConfirmProcessService } from '../../../shared/services/eca-confirm-process.service';
import { ExportExcelService } from '../../../common/services/export-excel.service';
import { BusinessUnitInfo } from '../../../message-models/business-unit.class';
import { ListDataService } from '../../../services/list-data.service';
import { IBusinessUnitInfo } from '../../../message-models/business-unit.interface';
import { BusinessUnitEditorComponent } from '../business-unit-editor/business-unit-editor.component';
import { OperativesService } from '../../../operatives/services/operatives.service';
import { BusinessUnitAssignComponent } from '../business-unit-assign/business-unit-assign.component';
import { OperativeInfo } from '../../../domain-model/operative-info.class';
import { CompanyEngagementHistory } from '../../../message-models/company-engagement-history.class';
import { ICompanyEngagementHistory } from '../../../message-models/company-engagement-history.interface';

@Component({
  selector: 'app-business-unit-list',
  templateUrl: './business-unit-list.component.html',
  styleUrls: ['./business-unit-list.component.scss']
})
export class BusinessUnitListComponent implements OnInit {

  private modalRef: IEcaDialogRef
  businessUnits: BusinessUnitInfo[] = [];
  selectedBusinessUnit: BusinessUnitInfo;
  showLoader: boolean = false;
  columns: any[];
  canAddItem: boolean = true;
  private loggedInUser: IUserInfo;
  rowMenuItems: MenuItem[];
  companyId: string;
  companyOperatives: OperativeInfo[] = [];

  constructor(
    private helpService: HelpModalService,
    private errorHandlingService: ErrorHandlingService,
    private userService: OurUserService,
    private ecaBreadcrumbService: EcaBreadcrumbService,
    private ecaDynamicModalService: EcaDynamicModalService,
    private confirmProcessService: EcaConfirmProcessService,
    private exportExcelService: ExportExcelService,
    private listDataService: ListDataService,
    private operativesService: OperativesService,

  ) { }

  isOnMobile = false;
  ngOnInit(): void {
    this.isOnMobile = window.outerWidth <= 480;
    this.userService.getLoggedInUser().subscribe(user => {
      this.loggedInUser = user;
      this.companyId = user.companyId;
      this.getCompanyBusinessUnits();
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    })
    this.columns = [
      { field: 'name', header: 'Business Unit Name', type: 'text' },
      { field: 'description', header: 'Business Unit Description', type: 'html' },
    ];
    this.populateBreadcrumbs();
    this.rowMenuItems = [
      {
        label: 'Remove',
        icon: 'fas fa-trash-alt',
        styleClass: 'eca-menu-item-red',
        command: ($event) => this.confirmDeleteItem($event)
      },
      {
        label: 'Assign',
        icon: 'fas fa-user-plus',
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.assignItemClick($event)
      }
    ]
  }

  private populateBreadcrumbs() {
    const settingsBreadCrumbs = new Array<IBreadcrumb>();
    settingsBreadCrumbs.push({ label: 'Business Units', iconName: 'building' } as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(settingsBreadCrumbs);
  }

  private getCompanyBusinessUnits() {
    this.listDataService.getBusinessUnitsForCompany(this.companyId).subscribe(businessUnitResult => {
      this.businessUnits = [];

      businessUnitResult.forEach(t => {
        if (!t.deleted) //only add the active business units
        {
          this.businessUnits.push(new BusinessUnitInfo(t));
        }
      })
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  addNewItemClick() {
    let businessUnit = new BusinessUnitInfo();
    businessUnit.companyId = this.companyId;
    this.openEditor(businessUnit, 'Add New Business Unit', 'Here you can add new Business Units which you can then assign to your Operatives.');
  }

  editItemClick(item: IBusinessUnitInfo) {
    let businessUnit = new BusinessUnitInfo(item);
    this.openEditor(businessUnit, 'Edit Existing Business Unit - ' + item.name, 'Here you can edit the name or description for your Business Units. <strong> NOTE: This will also update all operative records that have this business unit assigned </strong>');
  }

  assignItemClick(item: IBusinessUnitInfo) {
    this.selectedBusinessUnit = new BusinessUnitInfo(item);
    this.selectedBusinessUnit.companyId = this.companyId;
    this.openAssign(this.selectedBusinessUnit, 'Assign Business Unit - ' + item.name, 'Here you can assign business units to your Current Operatives. <strong> NOTE: This will overwrite the current business unit of an Operative if they already have one assigned</strong>');
  }

  private openAssign(businessUnit: BusinessUnitInfo, heading: string, helpText: string) {
    let config = {
      styleClass: 'modal-dialog-scrollable modal-lg',
      baseZIndex: 2000,
      showHeader: false,
      data: {
        heading: heading,
        businessUnit: businessUnit,
        helpText: helpText,
        allBusinessUnits: this.businessUnits
      }
    } as DynamicDialogConfig;
    this.modalRef = this.ecaDynamicModalService.openDialog(BusinessUnitAssignComponent, config);
    this.modalRef.content.choiceMade.subscribe(result => {
      if (result?.length > 0) {
        this.companyOperatives = result;
        this.companyOperatives.forEach(operative => {
          //get all engagements 
          this.operativesService.getCompanyEngagementsFor(operative.id, this.companyId).subscribe(operativeEngagments => {
            let engagement = new CompanyEngagementHistory({} as ICompanyEngagementHistory);
            //Get latest engagement
            engagement = new CompanyEngagementHistory(operativeEngagments.find(f => f.id == operative.latestEngagementId));
            engagement.businessUnit = this.selectedBusinessUnit;
            engagement.businessUnitId = this.selectedBusinessUnit.id;
            //Update engagement
            this.operativesService.createOrUpdateEngagement(engagement as ICompanyEngagementHistory).subscribe(engagement => {

            }, () => {
              this.errorHandlingService.showErrorWarning().subscribe(() => {
              });
            });
          });
        });
      }
    });
  }

  private openEditor(businessUnit: BusinessUnitInfo, heading: string, helpText: string) {
    let config = {
      styleClass: 'modal-dialog-scrollable modal-lg',
      baseZIndex: 2000,
      showHeader: false,
      data: {
        heading: heading,
        businessUnit: businessUnit,
        helpText: helpText
      }
    } as DynamicDialogConfig;
    this.modalRef = this.ecaDynamicModalService.openDialog(BusinessUnitEditorComponent, config);
    this.modalRef.content.choiceMade.subscribe(result => {
      if (result) {
        this.showLoader = true;
        this.listDataService.createOrUpdateBusinessUnit(result).subscribe(updatedBusinessUnit => {
          if (updatedBusinessUnit) {
            this.getCompanyBusinessUnits();
            this.showLoader = false;

            //This will trigger any component that is suscribed to this event.
            this.listDataService.updateLists();
          }
        }, () => {
          this.errorHandlingService.showErrorWarning().subscribe(() => {
          });
        });
      }
    });
  }

  confirmDeleteItem(businessUnit: IBusinessUnitInfo) {
    let businessUnitInUse = this.listDataService.getIsBusinessUnitInUse(businessUnit.id).subscribe(businessUnitInUse => {
      if (!businessUnitInUse) {
        this.confirmProcessService.openConfirmProcessModal("<p>Are you SURE you wish to DELETE this business unit?</p>",
          "Confirm Deletion", new EcaConfirmDeleteModalOptions())
          .subscribe(result => {
            if (result) {
              this.showLoader = true;
              this.listDataService.deleteBusinessUnit(businessUnit).subscribe(result => {
                this.getCompanyBusinessUnits();
                this.showLoader = false;

                //This will trigger any component that is suscribed to this event.
                this.listDataService.updateLists();
              }, () => {
                this.errorHandlingService.showErrorWarning().subscribe(() => {
                });
              });
            }
          });
      }
      else {
        this.helpService.openHelpModal(HelpConsts.BusinessUnitInUseHelp);
      }
    });
  }

  openBusinessUnitHelp() {
    this.helpService.openHelpModal(HelpConsts.BusinessUnitHelp);
  }

  exportToExcel() {
    this.exportExcelService.exportToExcel(this.businessUnits, this.columns, 'Business Units')
  }
}
